"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomerItem_1 = __importDefault(require("./CustomerItem"));
exports.default = CustomerItem_1.default;
